'use client';

import { Content, asText, isFilled } from '@prismicio/client';

import { RichTextDefault } from '@preventx/prismic-services';
import { Box, Flex, Link, Heading, LinkType } from '@preventx/oxygen';

// Services
import { retrieveIcon } from '@/services/styling/icons';

type WithSimpleContactDetailsProps = {
  sliceId: string;
  slice: Content.RegionSliceWithSimpleContactDetails;
};

export const WithSimpleContactDetails = ({
  slice,
  sliceId,
}: WithSimpleContactDetailsProps) => {
  const { primary } = slice;
  const { title, content, contact_details } = primary;

  return (
    <Box component="div" className="align-center">
      <Box component="div" addFlow>
        <Heading component="h2" className="headline__title">
          {asText(title)}
        </Heading>

        {isFilled.richText(content) && (
          <Box component="div" className="align-center">
            <RichTextDefault content={content} />
          </Box>
        )}

        <Flex horizontal="justify-center">
          <Box component="div" addCluster={contact_details.length > 1}>
            {contact_details.map(({ label, contact_value, type }, index) => {
              if (!isFilled.keyText(contact_value)) {
                return null;
              }

              const icon = type !== 'Default' ? retrieveIcon(type) : undefined;

              const linkType = {
                Email: 'mailto' satisfies LinkType,
                Default: 'default' satisfies LinkType,
                Phone: 'telephone' satisfies LinkType,
              }[type] as LinkType;

              return (
                <Link
                  type={linkType}
                  to={contact_value}
                  variant="button-primary"
                  key={`contact-details-region-${sliceId}-${index + 1}`}
                  icon={
                    icon ? { definition: icon, position: 'left' } : undefined
                  }
                >
                  {asText(label)}
                </Link>
              );
            })}
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};
